import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const { DANGER_STATUS_COLOR } = constants;

let styles = {
  container: {
    width: '100%',
    height: '100%'
  },
  error: {
    fontSize: '0.9em',
    fontWeight: 500,
    paddingTop: 3,
    paddingLeft: 1,
    color: DANGER_STATUS_COLOR
  },
  map: {
    height: 700,
    maxHeight: 'calc(100vh - 225px)'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/inputs/mapglinput/MapGLInput.styles.js